import React, { useState, useEffect } from 'react';

import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Autocomplete,
  createFilterOptions,
  CircularProgress,
  Grid,
  useTheme,
} from '@mui/material';

import ButtonWithSpinner from '../ButtonWithSpinner';
import ContactModal from '../ContactModal';

import { i18n } from '../../translate/i18n';
import api from '../../services/api';

import toastError from '../../toasts/toastError';

const filter = createFilterOptions({
  trim: true,
});

const ContactSendModal = ({ modalOpen, onClose }) => {
  const theme = useTheme();

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState('');
  const [selectedContact, setSelectedContact] = useState(null);
  const [newContact, setNewContact] = useState({});
  const [contactModalOpen, setContactModalOpen] = useState(false);

  useEffect(() => {
    try {
      if (!modalOpen || searchParam.length < 3) {
        return;
      }

      const fetchContacts = async () => {
        setLoading(true);
        const { data } = await api.get('contacts', {
          params: { searchParam, channel: 'whatsapp', isGroup: 'false' },
        });
        setOptions(data.contacts);
      };

      fetchContacts();
    } catch (e) {
      toastError(e);
    } finally {
      setLoading(false);
    }
  }, [searchParam, modalOpen]);

  const handleClose = () => {
    onClose();
    setSearchParam('');
    setSelectedContact(null);
  };

  const handleSendVcard = async (contact) => {
    if (!contact) return;

    setLoading(true);

    onClose(contact);

    setLoading(false);
  };

  const handleSelectOption = (e, newValue) => {
    if (newValue?.number) {
      setSelectedContact(newValue);
    } else if (newValue?.name) {
      setNewContact({ name: newValue.name });
      setContactModalOpen(true);
    }
  };

  const handleCloseContactModal = () => {
    setContactModalOpen(false);
  };

  const handleAddNewContactTicket = (contact) => {
    handleSendVcard(contact);
  };

  const createAddContactOption = (filterOptions, params) => {
    const filtered = filter(filterOptions, params);
    if (params.inputValue !== '' && !loading && searchParam.length >= 3) {
      filtered.push({
        name: `${params.inputValue}`,
      });
    }
    return filtered;
  };

  /* const renderOption = (option) => {
    if (option.number) {
      return (
        <>
          <Typography
            component='span'
            style={{
              fontSize: 14,
              marginLeft: '10px',
              display: 'inline-flex',
              alignItems: 'center',
              lineHeight: '2',
            }}
          >
            {option.name} - {option.number}
          </Typography>
        </>
      );
    } else {
      return `${i18n.t('SendContactModal.add')} ${option.name}`;
    }
  }; */

  const renderOptionLabel = (option) => {
    if (option.number) {
      return `${option.name} - ${option.number}`;
    } else {
      return `${option.name}`;
    }
  };

  const renderContactAutocomplete = () => {
    return (
      <Grid size={{ xs: 12 }}>
        <Autocomplete
          fullWidth
          options={options}
          loading={loading}
          clearOnBlur
          autoHighlight
          freeSolo
          clearOnEscape
          getOptionLabel={renderOptionLabel}
          filterOptions={createAddContactOption}
          onChange={(e, newValue) => handleSelectOption(e, newValue)}
          renderOption={(props, option) => (
            <li {...props}>
              {option.number ? (
                <Typography
                  component='span'
                  sx={{
                    fontSize: 14,
                    ml: 1,
                    display: 'inline-flex',
                    alignItems: 'center',
                    lineHeight: 2,
                  }}
                >
                  {option.name} - {option.number}
                </Typography>
              ) : (
                `${i18n.t('SendContactModal.add')} ${option.name}`
              )}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label={i18n.t('SendContactModal.fieldLabel')}
              sx={theme.custom.textField}
              variant='outlined'
              autoFocus
              onChange={(e) => setSearchParam(e.target.value)}
              onKeyDown={(e) => {
                if (loading || !selectedContact) return;

                if (e.key === 'Enter') {
                  handleSendVcard(selectedContact);
                }
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color='inherit' size={20} />
                    ) : null}

                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </Grid>
    );
  };

  return (
    <>
      <ContactModal
        open={contactModalOpen}
        initialValues={newContact}
        onClose={handleCloseContactModal}
        onSave={handleAddNewContactTicket}
      ></ContactModal>
      <Dialog open={modalOpen} onClose={handleClose}>
        <DialogTitle id='form-dialog-title' sx={theme.custom.dialogColor}>
          {i18n.t('SendContactModal.title')}
        </DialogTitle>
        <DialogContent dividers sx={theme.custom.dialogColor}>
          <Grid sx={{ width: 300 }} container spacing={2}>
            {/* CONTATO */}
            {renderContactAutocomplete()}
          </Grid>
        </DialogContent>
        <DialogActions sx={theme.custom.dialogColor}>
          <Button
            onClick={handleClose}
            disabled={loading}
            variant='outlined'
            sx={theme.custom.cancelButton}
          >
            {i18n.t('SendContactModal.buttons.cancel')}
          </Button>
          <ButtonWithSpinner
            variant='outlined'
            type='button'
            disabled={!selectedContact}
            onClick={() => handleSendVcard(selectedContact)}
            sx={theme.custom.confirmButton}
            loading={loading}
          >
            {i18n.t('SendContactModal.buttons.ok')}
          </ButtonWithSpinner>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ContactSendModal;
